import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import Alert from '../Alert';

interface IntroductionProps {
	onManualEntry: () => void;
	onImportClick: () => void;
	handleTriggerAppStatePolling?: () => void;
	openedFromQuoteSelection?: boolean;
}

const Introduction = ({
	onManualEntry,
	onImportClick,
	openedFromQuoteSelection = false
}: IntroductionProps) => {
	const { t } = useTranslation();

	return (
		<div data-testid="employees-introduction-view">
			<h6 className="font-bold text-lg mb-2">{t('quotes.settings.employees.title')}</h6>
			{openedFromQuoteSelection && (
				<Alert
					variant="info"
					className="my-4"
					testId="employees-info-alert"
					showIcon
					text={t('quotes.settings.employees.updateWarning')}
				/>
			)}
			<div className="text-muted-foreground font-medium">
				<span className="block mb-1">
					{t('quotes.settings.employees.introduction.estimate')}
					<span className="text-foreground opacity-75 font-bold ml-1">
						{t('quotes.settings.employees.introduction.basedOnData')}
					</span>
					.
				</span>
				<span className="block">
					{t('quotes.settings.employees.introduction.enterCurrent')}
					<span className="text-foreground opacity-75 font-bold ml-1 mr-1">
						{t('quotes.settings.employees.introduction.currentData')}
					</span>
					{t('quotes.settings.employees.introduction.forAccurate')}
					<span className="text-foreground opacity-75 font-bold ml-1">
						{t('quotes.settings.employees.introduction.accuratePremium')}
					</span>
					.
				</span>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-5">
					<Button
						type="button"
						className="w-full"
						onClick={onManualEntry}
						data-testid="introduction-manual-entry-button"
					>
						{t('quotes.settings.employees.introduction.manualButton')}
					</Button>
					<Button
						type="button"
						className="w-full"
						onClick={onImportClick}
						data-testid="introduction-import-button"
					>
						{t('quotes.settings.employees.introduction.importButton')}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default Introduction;
